
import { combineReducers } from 'redux';
import { 
    ALERT_CREATED,
    BLOGPOST_CREATED, BLOGPOSTS_LOADED, BLOGPOST_UPDATED,
    CLASS_CREATED, CLASSES_LOADED, CLASS_UPDATED,
    COURSE_CREATED, COURSES_LOADED, COURSE_UPDATED,
    EVENT_CREATED,
    ORG_LOADED, ORG_UPDATED,
    LESSON_CREATED, LESSONS_LOADED, LESSON_UPDATED,
    LOCATION_CREATED, LOCATIONS_LOADED, LOCATION_UPDATED,
    PRODUCT_CREATED, PRODUCTS_LOADED, PRODUCT_UPDATED,
    SCHOOL_CREATED, SCHOOLS_LOADED, SCHOOL_UPDATED,
    STUDENT_CREATED, STUDENTS_LOADED, STUDENT_UPDATED,
    TEACHER_CREATED, TEACHERS_LOADED, TEACHER_UPDATED,
    USER_LOGGEDIN, USER_LOGGEDOUT,
    VIDEO_CREATED, VIDEOS_LOADED, VIDEO_UPDATED,
    SEARCH_USERS, SEARCH_RESULTS, CLEAR_SEARCH
} from './actions';

// generic sort comparer
function compareName(a,b) {

    var aName = a.Name;
    var bName = b.Name;
  
    if (aName < bName)
      return -1;
    if (aName > bName)
      return 1;
    return 0;
}


function comparePublishDate(a,b) {

    var aName = a.PublishDate;
    var bName = b.PublishDate;
    
    if (aName < bName)
        return -1;
    if (aName > bName)
        return 1;
    return 0;
}


function alerts(state = [], action) {
    
    switch (action.type) {
        case ALERT_CREATED:
            return action.alert;

        default:
            return state;
    }
}


function blogPosts(state = [], action) {
    
    switch (action.type) {
        
        case BLOGPOST_CREATED:
            var g1 = state.splice();
            g1.push(action.blogPost);
            return g1.sort(comparePublishDate);

        case BLOGPOSTS_LOADED:
            return action.blogPosts.sort(comparePublishDate);

        case BLOGPOST_UPDATED:
            var g2 = state.splice();
            for(var i = 0; i < g2.length; i++) {
                if(g2[i].id === action.blogPost.id) {
                    g2[i] = action.blogPost;
                    break;
                }                
            }
            return g2.sort(comparePublishDate);

        default:
            return state.sort(comparePublishDate);
    }
}

function classRooms(state = [], action) {
    
    switch (action.type) {
        
        case CLASS_CREATED:
            state.push(action.class);
            return state.sort(compareName);

        case CLASSES_LOADED:
            return action.classes;

        case CLASS_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.class.id) {
                    state[i] = action.class;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function courses(state = [], action) {
    
    switch (action.type) {
        
        case COURSE_CREATED:
            state.push(action.course);
            return state.sort(compareName);

        case COURSES_LOADED:
            return action.courses;

        case COURSE_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.course.id) {
                    state[i] = action.course;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function events(state = [], action) {
    
    switch (action.type) {
        case EVENT_CREATED:
            return action.event;

        default:
            return state;
    }
}

function products(state = [], action) {
    
    switch (action.type) {
        case PRODUCT_CREATED:

            state.push(action.product);
            return state.sort(compareName);

        case PRODUCTS_LOADED:

            return action.products;

        case PRODUCT_UPDATED:

            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.product.id) {
                    state[i] = action.product;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function org(state = null, action) {
    
    switch (action.type) {
        case ORG_LOADED:

            return {
                id: action.org.id,
                name: action.org.name,
                description: action.org.description,
                website: action.org.website,
                latitude: action.org.latitude,
                longitude: action.org.longitude
            }

        case ORG_UPDATED:

            return {
                id: action.org.id,
                name: action.org.name,
                description: action.org.description,
                website: action.org.website,
                latitude: action.org.latitude,
                longitude: action.org.longitude
            }

        default:
            return state;
    }
}

function lessons(state = [], action) {
    
    switch (action.type) {
        
        case LESSON_CREATED:
            state.push(action.lesson);
            return state.sort(compareName);

        case LESSONS_LOADED:
            return action.lessons;

        case LESSON_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.lesson.id) {
                    state[i] = action.lesson;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function locations(state = [], action) {

    switch (action.type) {
        
        case LOCATION_CREATED:
            state.push(action.location);
            return state.sort(compareName);

        case LOCATIONS_LOADED:
            return action.locations;

        case LOCATION_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.location.id) {
                    state[i] = action.location;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function schools(state = [], action) {
    
    switch (action.type) {
        
        case SCHOOL_CREATED:
        var g1 = state.splice();
        g1.push(action.school);
        return g1.sort(compareName);

        case SCHOOLS_LOADED:
            return action.schools.sort(compareName);

        case SCHOOL_UPDATED:
            var g2 = state.splice();
            for(var i = 0; i < g2.length; i++) {
                if(g2[i].id === action.school.id) {
                    g2[i] = action.school;
                    break;
                }                
            }
            return g2.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function students(state = [], action) {
    
    switch (action.type) {
        
        case STUDENT_CREATED:
            state.push(action.student);
            return state.sort(compareName);

        case STUDENTS_LOADED:
            return action.students;

        case STUDENT_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.student.id) {
                    state[i] = action.student;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}


function teachers(state = [], action) {
    
    switch (action.type) {
        
        case TEACHER_CREATED:
            state.push(action.teacher);
            return state.sort(compareName);

        case TEACHERS_LOADED:
            state = action.teachers;
            return state;

        case TEACHER_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.teacher.id) {
                    state[i] = action.teacher;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function user(state = {authenticated: false}, action) {
    
    switch (action.type) {
        case USER_LOGGEDIN:
            return {
                authenticated: true,
                id: action.user.id,
                email: action.user.email,
                firstName: action.user.firstName,
                lastName: action.user.lastName,
                orgId: action.user.orgID,
                schoolID: action.user.schoolID,
                classID: action.user.classID,
                userType: action.user.userType
                }

        case USER_LOGGEDOUT:

            return {
                authenticated: false
            }

        default:
            return state;
    }
}

function videos(state = [], action) {
    
    switch (action.type) {
        
        case VIDEO_CREATED:
            state.push(action.videos);
            return state.sort(compareName);

        case VIDEOS_LOADED:
            state = action.videos;
            return state;

        case VIDEO_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.video.id) {
                    state[i] = action.video;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function search(state = { active: false, loading: false, query: '', results: [] }, action) {
    
    switch (action.type) {
        case SEARCH_USERS:
            return {
                active: true,
                loading: true,
                query: action.query,
                results: []
            };

        case SEARCH_RESULTS:
            return {
                ...state,
                loading: false,
                results: action.results
            };

        case CLEAR_SEARCH:
            return {
                active: false,
                loading: false,
                query: '',
                results: []
            };

        default:
            return state;
    }
}

const Reducers = combineReducers({ 
    alerts,
    blogPosts,
    classRooms,
    courses,
    events,
    lessons,
    locations,
    org, 
    products,
    schools,
    students,
    teachers,
    user,
    videos,
    search
})

const appState = (Reducers)

export default appState



// WEBPACK FOOTER //
// ./src/redux/reducers.js